<div class="meeting-demand-modal-wrapper">
  <div class="meeting-info">
    <div class="info-container">
      <img src="../../../assets/img/meet.svg" />
      <h2>{{ "RDV_PAGE.CONFIRM_MODAL.CONFIRM_TITLE" | translate }}</h2>
      <p>
        {{ convertDate(meet.date) }}
        {{ displayTime(this.meet.time_start, this.meet.time_end) }}
      </p>
    </div>
  </div>
  <div class="buttons-group">
    <div class="bloc-choices">
      <div class="bloc-choices__group">
        <input
          type="radio"
          class="bloc-choices__group__radio"
          value="accept"
          id="accept"
          name="choice"
          [(ngModel)]="choice"
        />
        <label class="bloc-choices__group__label" for="accept"
          >{{ "RDV_PAGE.CONFIRM_MODAL.VALIDE_RDV" | translate }}
        </label>
      </div>
      <div class="bloc-choices__group">
        <input
          type="radio"
          class="bloc-choices__group__radio"
          value="cancel"
          id="cancel"
          name="choice"
          [(ngModel)]="choice"
        />
        <label class="bloc-choices__group__label" for="cancel"
          >{{ "RDV_PAGE.CONFIRM_MODAL.NEW_RDV" | translate }}</label
        >
      </div>
    </div>
    <app-button
      [innerText]="'RDV_PAGE.CONFIRM_MODAL.ACCEPT_BTN' | translate"
      (onClick)="handleValid()"
      [loading]="isLoading"
      [disabled]="isLoading"
    >
    </app-button>
    <app-button
      [styles]="{ backgroundColor: '#88a8c7' }"
      [innerText]="'RDV_PAGE.CONFIRM_MODAL.CANCEL_BTN_2' | translate"
      (onClick)="cancelDemande()"
    >
    </app-button>
  </div>
</div>
